import { Component } from '@angular/core';

@Component({
  selector: 'animated-border-wrapper',
  standalone: true,
  templateUrl: './animated-border-wrapper.component.html',
  styleUrls: ['./animated-border-wrapper.component.scss']
})
export class AnimatedBorderWrapperComponent {}
